import { Global } from '@emotion/react';
import React from 'react';

const Fonts = () => {
  return (
    <Global
      styles={`
        @font-face {
          font-family: JennaSue;
          font-style: normal;
          font-weight: 400;
          src: url('/font/JennaSue.woff2') format('woff2'),
            url('/font/JennaSue.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: JennaSuePro;
          font-style: normal;
          font-weight: 400;
          src: url('/font/JennaSuePro.woff2') format('woff2'),
            url('/font/JennaSuePro.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova;
          font-style: normal;
          font-weight: 100;
          src: url('/font/ProximaNova-Light.woff2') format('woff2'),
            url('/font/ProximaNova-Light.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova;
          font-style: normal;
          font-weight: 300;
          src: url('/font/ProximaNova-Light.woff2') format('woff2'),
            url('/font/ProximaNova-Light.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova;
          font-style: normal;
          font-weight: 400;
          src: url('/font/ProximaNova-Regular.woff2') format('woff2');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova;
          font-style: normal;
          font-weight: 500;
          src: url('/font/ProximaNova-Medium.woff2') format('woff2');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova;
          font-style: normal;
          font-weight: 600;
          src: url('/font/ProximaNova-Semibold.woff2') format('woff2');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova;
          font-style: normal;
          font-weight: 700;
          src: url('/font/ProximaNova-Bold.woff2') format('woff2');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova;
          font-style: normal;
          font-weight: 800;
          src: url('/font/ProximaNova-Extrabld.woff2') format('woff2'),
            url('/font/ProximaNova-Extrabld.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova;
          font-style: normal;
          font-weight: 900;
          src: url('/font/ProximaNova-Black.woff2') format('woff2'),
            url('/font/ProximaNova-Black.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova-Bold;
          font-style: normal;
          font-weight: 700;
          src: url('/font/ProximaNova-Bold.woff2') format('woff2');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova-Semibold;
          font-style: normal;
          font-weight: 600;
          src: url('/font/ProximaNova-Semibold.woff2') format('woff2');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova-Regular;
          font-style: normal;
          font-weight: 400;
          src: url('/font/ProximaNova-Regular.woff2') format('woff2');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova-Light;
          font-style: normal;
          font-weight: 300;
          src: url('/font/ProximaNova-Light.woff2') format('woff2'),
            url('/font/ProximaNova-Light.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: ProximaNova-Extrabld;
          font-style: normal;
          font-weight: 800;
          src: url('/font/ProximaNova-Extrabld.woff2') format('woff2'),
            url('/font/ProximaNova-Extrabld.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: Gelica;
          font-style: normal;
          font-weight: 300;
          src: url('/font/Gelica-Light.woff2') format('woff2'),
            url('/font/Gelica-Light.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: Gelica;
          font-style: normal;
          font-weight: 400;
          src: url('/font/Gelica-Regular.woff2') format('woff2'),
            url('/font/Gelica-Regular.woff') format('woff');
          font-display: swap;
        }
        @font-face {
          font-family: Gelica;
          font-style: normal;
          font-weight: 500;
          src: url('/font/Gelica-Medium.woff2') format('woff2'),
            url('/font/Gelica-Medium.woff') format('woff');
          font-display: swap;
        }
`}
    />
  );
};

export default Fonts;
